const { Serializer } = require("jsonapi-serializer");

module.exports = {
  tokensSerializer: (meta = {}) =>
    new Serializer("refresh-tokens", {
      meta,
      pluralizeType: false,
      keyForAttribute: "snake_case",
      attributes: ["refreshToken"]
    })
};
